import SessionApi from '@opendoor/shared-fe/build/api/session';

import { COOKIE_KEY, WEB_API_URL } from '../helpers/globals';

export const Session = new SessionApi(COOKIE_KEY, WEB_API_URL);
